import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../Button/ButtonSideNav"
import Card from "../../Cards/Card";

import classes from './NotificationCard.module.css';

import userIcon_Black from "../../../../assets/portalAssets/usericonB.png";

import warningNotifcationIcon from "../../../../assets/portalAssets/warningNotificationIconW.png";
import loginIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Navigation Icons/__Logout.svg"
import closeIconW from "../../../../assets/portalAssets/closeIconW.png";
import { uiActions } from "../../../../store/ui-slice";
import { Bounce, ToastContainer, toast } from 'react-toastify';

const NotificationCard = (props) => {
  // const lineRef = useRef(null);


  // const dispatch = useDispatch();
  // let toggleNotification = useSelector(state => state.ui.toggleNotification);

  // if (!toggleNotification) {
  //   toggleNotification = true;
  // }

  // let headerclasses = '';
  // let lineclasses = '';

  // if (props.status === 'error') {
  //   headerclasses = classes.headerError;
  //   lineclasses = classes.lineError;
  // }
  // if (props.status === 'success') {
  //   headerclasses = classes.headerSuccess;
  //   lineclasses = classes.lineSuccess;
  // }


  // const timeDuration = 10;

  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     dispatch(uiActions.toggleNotification());
  //   }, timeDuration * 700); 

  //   const animationDuration = timeDuration; 
  //   const lineElement = lineRef.current;
  //   if (lineElement) {
  //     lineElement.style.animationDuration = `${animationDuration}s`;
  //   }

  //   return () => {
  //     clearTimeout(timeoutId);

  //   };
  // }, [dispatch, toggleNotification]);

  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      transition={Bounce}
    />
  );
}

export default NotificationCard;